var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FeatureScope } from "healthex-common/feature-enablement.utils";
import { FeatureUpdateInput } from "healthex-common/features.dtos";
import { observable, runInAction } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export const GLOBAL_FEATURE_ENABLEMENT_SCOPE = {};
export class GlobalAdminFeatureEnablementManager {
    constructor(globalAdminFeatureEnablementService) {
        this.globalAdminFeatureEnablementService = globalAdminFeatureEnablementService;
        this.scopeKey = GLOBAL_FEATURE_ENABLEMENT_SCOPE;
        this.overview = NOT_LOADED;
        this.loadGeneration = 0;
    }
    async loadScope(key) {
        const generation = ++this.loadGeneration;
        runInAction(() => {
            this.scopeKey = key;
            this.overview = NOT_LOADED;
        });
        const overview = await this.globalAdminFeatureEnablementService.getOverview(key.organizationId, key.patientId);
        if (generation !== this.loadGeneration) {
            return;
        }
        runInAction(() => {
            this.overview = overview;
        });
    }
    async updateFeatureAtScope(scope, feature, enabled, configuration) {
        const input = new FeatureUpdateInput({ feature, enabled, configuration });
        switch (scope) {
            case FeatureScope.GLOBAL:
                await this.globalAdminFeatureEnablementService.updateGlobalFeature(input);
                break;
            case FeatureScope.ORGANIZATION: {
                const organizationId = this.scopeKey.organizationId;
                if (!organizationId) {
                    throw new Error(`Organization scope requires an organization ID`);
                }
                await this.globalAdminFeatureEnablementService.updateOrganizationFeature(organizationId, input);
                break;
            }
            case FeatureScope.PATIENT: {
                const patientId = this.scopeKey.patientId;
                if (!patientId) {
                    throw new Error(`Patient scope requires a patient ID`);
                }
                await this.globalAdminFeatureEnablementService.updatePatientFeature(patientId, input);
                break;
            }
        }
    }
}
__decorate([
    observable
], GlobalAdminFeatureEnablementManager.prototype, "scopeKey", void 0);
__decorate([
    observable
], GlobalAdminFeatureEnablementManager.prototype, "overview", void 0);
